<template>
  <div id="app" style="width: 100%; display: flex;">
    <!-- 左侧用户列表（仅管理员可见） -->
    <div v-if="isAdmin" class="user-sidebar">
      <div class="sidebar-header">用户列表</div>
      <div class="user-list">
        <div
          class="user-item"
          :class="{ active: selectedUserId === null }"
          @click="selectUser(null)">
          <span class="user-name">全部设备</span>
        </div>
        <div
          v-for="user in userList"
          :key="user.id"
          class="user-item"
          :class="{ active: selectedUserId === user.id }"
          @click="selectUser(user.id)">
          <span class="user-name">{{ user.username }}</span>
          <span class="user-role">({{ user.role ? user.role.name : '无角色' }})</span>
        </div>
      </div>
    </div>
    <!-- 右侧设备列表 -->
    <div class="device-main" :style="deviceMainStyle">
    <div class="page-header">
      <div class="page-title">设备列表</div>
      <div class="page-header-btn">
        <el-select v-model="searchType" size="mini" style="width: 110px; margin-right: 6px;">
          <el-option label="全部" value="all"></el-option>
          <el-option label="名称" value="name"></el-option>
          <el-option label="设备编号" value="deviceId"></el-option>
        </el-select>
        <el-input
          v-model="searchKeyword"
          placeholder="搜索名称或编号"
          size="mini"
          clearable
          style="width: 220px; margin-right: 6px;"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch">
        </el-input>
        <el-button icon="el-icon-search" size="mini" style="margin-right: 1rem;" type="primary" @click="handleSearch">搜索</el-button>
        <el-button icon="el-icon-plus" size="mini" style="margin-right: 1rem;" type="success" @click="add">添加设备
        </el-button>
        <el-button icon="el-icon-refresh-right" circle size="mini" :loading="getDeviceListLoading"
                   @click="getDeviceList()"></el-button>
      </div>
    </div>
    <!--设备列表-->
    <div class="table-card">
    <el-table :data="deviceList" style="width: 100%;font-size: 12px;" :height="winHeight" header-row-class-name="table-header">
      <el-table-column prop="name" label="名称" min-width="160">
      </el-table-column>
      <el-table-column prop="deviceId" label="设备编号" min-width="200" >
      </el-table-column>
      <el-table-column label="地址" min-width="160" >
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-tag v-if="scope.row.hostAddress" size="medium">{{ scope.row.hostAddress }}</el-tag>
            <el-tag v-if="!scope.row.hostAddress" size="medium">未知</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="manufacturer" label="厂家" min-width="120" >
      </el-table-column>
      <el-table-column prop="transport" label="信令传输模式" min-width="120" >
      </el-table-column>
      <el-table-column label="流传输模式"  min-width="160" >
        <template slot-scope="scope">
          <el-select size="mini" @change="transportChange(scope.row)" v-model="scope.row.streamMode" placeholder="请选择" style="width: 120px">
            <el-option key="UDP" label="UDP" value="UDP"></el-option>
            <el-option key="TCP-ACTIVE" label="TCP主动模式"  value="TCP-ACTIVE"></el-option>
            <el-option key="TCP-PASSIVE" label="TCP被动模式" value="TCP-PASSIVE"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="channelCount" label="通道数" min-width="120" >
      </el-table-column>
      <el-table-column label="状态" min-width="120">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-tag size="medium" v-if="scope.row.onLine">在线</el-tag>
            <el-tag size="medium" type="info" v-if="!scope.row.onLine">离线</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="keepaliveTime" label="最近心跳" min-width="160" >
      </el-table-column>
      <el-table-column prop="registerTime" label="最近注册"  min-width="160">
      </el-table-column>
<!--      <el-table-column prop="updateTime" label="更新时间"  width="140">-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="createTime" label="创建时间"  width="140">-->
<!--      </el-table-column>-->

      <el-table-column label="操作" min-width="450" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="medium" v-bind:disabled="scope.row.online==0" icon="el-icon-refresh" @click="refDevice(scope.row)"
                     @mouseover="getTooltipContent(scope.row.deviceId)">刷新
          </el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button type="text" size="medium" icon="el-icon-video-camera"
                     @click="showChannelList(scope.row)">通道
          </el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button size="medium" icon="el-icon-location" type="text"
                     @click="showDevicePosition(scope.row)">定位
          </el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button size="medium" icon="el-icon-edit" type="text" @click="edit(scope.row)">编辑</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button size="medium" icon="el-icon-delete" type="text" class="delete-btn" @click="deleteDevice(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-size="count"
      :page-sizes="[15, 25, 35, 50]"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    </div>
    <deviceEdit ref="deviceEdit"></deviceEdit>
    <syncChannelProgress ref="syncChannelProgress"></syncChannelProgress>
    </div>
  </div>
</template>

<script>
import uiHeader from '../layout/UiHeader.vue'
import deviceEdit from './dialog/deviceEdit.vue'
import syncChannelProgress from './dialog/SyncChannelProgress.vue'
import userService from '../components/service/UserService'

export default {
  name: 'app',
  components: {
    uiHeader,
    deviceEdit,
    syncChannelProgress,
  },
  data() {
    return {
      deviceList: [], //设备列表
      currentDevice: {}, //当前操作设备对象

      videoComponentList: [],
      updateLooper: 0, //数据刷新轮训标志
      currentDeviceChannelsLenth: 0,
      winHeight: window.innerHeight - 200,
      currentPage: 1,
      count: 15,
      total: 0,
      getDeviceListLoading: false,
      searchKeyword: '',
      searchType: 'all',
      userList: [], // 用户列表
      selectedUserId: null, // 管理员选中的用户ID，null=全部
    };
  },
  computed: {
    isAdmin: function () {
      const user = userService.getUser();
      return user && user.role && user.role.id === 1;
    },
    deviceMainStyle: function () {
      if (this.isAdmin) {
        return { flex: '1', width: 'calc(100% - 196px)' };
      }
      return { width: '100%' };
    },
    getcurrentDeviceChannels: function () {
      let data = this.currentDevice['channelMap'];
      let channels = null;
      if (data) {
        channels = Object.keys(data).map(key => {
          return data[key];
        });
        this.currentDeviceChannelsLenth = channels.length;
      }
      return channels;
    }
  },
  mounted() {
    this.initData();
    this.updateLooper = setInterval(this.initData, 10000);
    if (this.isAdmin) {
      this.getUserList();
    }
  },
  destroyed() {
    this.$destroy('videojs');
    clearTimeout(this.updateLooper);
  },
  methods: {
    initData: function () {
      this.getDeviceList();
    },
    currentChange: function (val) {
      this.currentPage = val;
      this.getDeviceList();
    },
    handleSizeChange: function (val) {
      this.count = val;
      this.getDeviceList();
    },
    getDeviceList: function () {
      this.getDeviceListLoading = true;
      let params = {
        page: this.currentPage,
        count: this.count
      };
      // 管理员：默认不传userId（看全部），选中用户时传userId
      // 非管理员：始终传自己的userId
      if (this.isAdmin) {
        if (this.selectedUserId !== null) {
          params.userId = this.selectedUserId;
        }
      } else {
        params.userId = userService.getUser().id;
      }
      // 附加搜索参数
      if (this.searchKeyword && this.searchKeyword.trim()) {
        params.query = this.searchKeyword.trim();
        params.qType = this.searchType;
      }
      this.$axios({
        method: 'get',
        url: `/api/device/query/devices`,
        params: params
      }).then( (res)=> {
        if (res.data.code === 0) {
          this.total = res.data.data.total;
          this.deviceList = res.data.data.list;
        }
        this.getDeviceListLoading = false;
      }).catch( (error)=> {
        console.error(error);
        this.getDeviceListLoading = false;
      });
    },
    handleSearch: function () {
      this.currentPage = 1;
      this.getDeviceList();
    },
    deleteDevice: function (row) {
      let msg = "确定删除此设备？"
      if (row.online !== 0) {
        msg = "在线设备删除后仍可通过注册再次上线。<br/>如需彻底删除请先将设备离线。<br/><strong>确定删除此设备？</strong>"
      }
      this.$confirm(msg, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'delete',
          url: `/api/device/query/devices/${row.deviceId}/delete`
        }).then((res) => {
          this.getDeviceList();
        }).catch((error) => {
          console.error(error);
        });
      }).catch(() => {

      });


    },
    showChannelList: function (row) {
      this.$router.push(`/channelList/${row.deviceId}/0`);
    },
    showDevicePosition: function (row) {
      this.$router.push(`/map?deviceId=${row.deviceId}`);
    },

    //gb28181平台对接
    //刷新设备信息
    refDevice: function (itemData) {
      console.log("刷新对应设备:" + itemData.deviceId);
      let that = this;
      this.$axios({
        method: 'get',
        url: '/api/device/query/devices/' + itemData.deviceId + '/sync'
      }).then((res) => {
        console.log("刷新设备结果：" + JSON.stringify(res));
        if (res.data.code !== 0) {
          that.$message({
            showClose: true,
            message: res.data.msg,
            type: 'error'
          });
        } else {
          // that.$message({
          // 	showClose: true,
          // 	message: res.data.msg,
          // 	type: 'success'
          // });
          this.$refs.syncChannelProgress.openDialog(itemData.deviceId)
        }
        that.initData()
      }).catch((e) => {
        console.error(e)
        that.$message({
          showClose: true,
          message: e,
          type: 'error'
        });
      });

    },

    getTooltipContent: async function (deviceId) {
      let result = "";
      await this.$axios({
        method: 'get',
        async: false,
        url: `/api/device/query/${deviceId}/sync_status/`,
      }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.errorMsg !== null) {
            result = res.data.data.errorMsg
          } else if (res.data.msg !== null) {
            result = res.data.msg
          } else {
            result = `同步中...[${res.data.data.current}/${res.data.data.total}]`;
          }
        }
      })
      return result;
    },
    transportChange: function (row) {
      console.log(`修改传输方式为 ${row.streamMode}：${row.deviceId} `);
      let that = this;
      this.$axios({
        method: 'post',
        url: '/api/device/query/transport/' + row.deviceId + '/' + row.streamMode
      }).then(function (res) {

      }).catch(function (e) {
      });
    },
    edit: function (row) {
      this.$refs.deviceEdit.openDialog(row, () => {
        this.$refs.deviceEdit.close();
        this.$message({
          showClose: true,
          message: "设备修改成功，通道字符集将在下次更新生效",
          type: "success",
        });
        setTimeout(this.getDeviceList, 200)

      })
    },
    add: function () {
      this.$refs.deviceEdit.openDialog(null, () => {
        this.$refs.deviceEdit.close();
        this.$message({
          showClose: true,
          message: "添加成功",
          type: "success",
        });
        setTimeout(this.getDeviceList, 200)

      })
    },
    getUserList: function () {
      this.$axios({
        method: 'get',
        url: '/api/user/all'
      }).then((res) => {
        if (res.data && res.data.data) {
          this.userList = res.data.data;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectUser: function (userId) {
      this.selectedUserId = userId;
      this.currentPage = 1;
      this.getDeviceList();
    }


  }
};
</script>

<style>
/* 表格卡片容器 — 匹配 Login 卡片风格 */
.table-card {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

/* 用户侧边栏 — 白色卡片风格，匹配 Login */
.user-sidebar {
  width: 180px;
  min-width: 180px;
  margin-right: 16px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sidebar-header {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  padding: 16px 18px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
}
.user-list {
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
}
.user-item {
  padding: 10px 18px;
  cursor: pointer;
  font-size: 13px;
  border: none;
  margin: 2px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.user-item:hover {
  background: #ecf5ff;
  color: #409EFF;
}
.user-item.active {
  background: #409EFF;
  color: #fff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}
.user-item.active .user-name,
.user-item.active .user-role {
  color: #fff;
}
.user-name {
  color: #303133;
}
.user-role {
  font-size: 11px;
  color: #909399;
  margin-left: 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/DeviceList.vue